module.exports = __webpack_public_path__ + "static/img/mesplaques.e7212c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/bg/mesplaques.jpg
// module id = MeO5
// module chunks = 1